/**
 * @fileoverview TourTrackingForm.jsx
 * 
 * © 2026 KITH Travels (Pvt) Ltd. All rights reserved.
 * This software is the confidential and proprietary information of KITH Travels.
 * You shall not disclose such Confidential Information and shall use it only in 
 * accordance with the terms of the license agreement you entered into with KITH Travels.
 */
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

function TourTrackingForm({ setShowCard, setTourID }) {
    const { t } = useTranslation();
    const[searchTourId, setSearchTourId] = useState('');
    const[isFocused, setIsFocused] = useState(false);
    const[loading, setLoading] = useState(false);

    const handleTourSearch = (e) => {
        e.preventDefault();
        setLoading(true);
        // Simulate a slight delay for better UX
        setTimeout(() => {
            setTourID(searchTourId);
            setShowCard(true);
            setLoading(false);
        }, 500);
    };

  return (
    <form 
        onSubmit={handleTourSearch} 
        className={`flex p-1.5 bg-white rounded-2xl shadow-lg border-2 transition-all duration-300 ${isFocused ? 'border-KITH-primary ring-4 ring-KITH-primary/10' : 'border-gray-100'}`}
    >
        <input 
            type="text" 
            name='tourNumber' 
            value={searchTourId} 
            onChange={(e) => setSearchTourId(e.target.value)} 
            onFocus={() => setIsFocused(true)} 
            onBlur={() => setIsFocused(false)} 
            className='w-full px-5 py-3 text-base md:text-lg outline-none bg-transparent' 
            placeholder={t('find_tour.placeholder')} 
            required 
        />
        <button 
            type="submit" 
            disabled={loading} 
            className='px-8 py-3 bg-KITH-primary text-white font-bold rounded-xl hover:bg-KITH-primary-dark transition-all disabled:opacity-50 flex items-center justify-center gap-2'
        >
            {loading ? (
                <div className='w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin'></div>
            ) : (
                <>
                    <i className='fi fi-br-search mt-1'></i>
                    <span>{t('find_tour.track')}</span>
                </>
            )}
        </button>
    </form>
  )
}

export default TourTrackingForm